import { useMemo } from 'react';

import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

const RedirectLegacyEarnRoutes = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const redirectPath = useMemo(() => {
    // Extract the path segment after '/earn/' and normalize slashes
    const rawPathSegment = location.pathname.split('/earn/')[1] || '';
    const pathSegment = rawPathSegment.replace(/^\/+/, '').replace(/\/+$/, '');
    const searchParamString = searchParams.toString();
    const withSearchParams = (path: string) =>
      searchParamString ? `${path}?${searchParamString}` : path;

    // Route mapping: /earn/* -> new destination
    if (!pathSegment) {
      return withSearchParams('/rewards');
    }

    if (pathSegment === 'in-store') {
      return withSearchParams('/rewards/dining');
    }

    if (pathSegment === 'online') {
      return withSearchParams('/rewards/online');
    }

    // Default: move everything else under /rewards
    return withSearchParams(`/rewards/${pathSegment}`);
  }, [location.pathname, searchParams]);

  return <Navigate to={redirectPath} replace />;
};

export { RedirectLegacyEarnRoutes };
